import axios from "~/plugins/axios";

export default {
  find(mortgageProgressId, includes = []) {
    return axios.get(`/web_api/v1/mortgage_progress/${mortgageProgressId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  create(mortgageProgress) {
    return axios.post("/web_api/v1/mortgage_progress", mortgageProgress)
      .then((response) => response.data);
  },
  createByDocumentTypes(mortgageId, documentTypes) {
    return axios.post("/web_api/v1/mortgage_progress/by_document_types", {
      mortgage_id: mortgageId,
      document_type_ids: documentTypes.map((documentType) => documentType.id),
    }).then((response) => response.data);
  },
  update(mortgageProgress) {
    return axios.put(`/web_api/v1/mortgage_progress/${mortgageProgress.id}`, mortgageProgress)
      .then((response) => response.data);
  },
  updateMultiple(mortgageProgresses) {
    return axios.put("/web_api/v1/mortgage_progress/update_multiple", {
      mortgage_progresses: mortgageProgresses,
    }).then((response) => response.data);
  },
  delete(mortgageProgressId) {
    return axios.delete(`/web_api/v1/mortgage_progress/${mortgageProgressId}`)
      .then((response) => response.data);
  },
  getByMortgage(mortgageId, includes = []) {
    return axios.get(`/web_api/v1/mortgage_progress/by_mortgage/${mortgageId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
};
